import React, { useState } from "react";
import { Input, Row, Typography, Col, Card, Select, Form } from "antd";
import data from "../../../../../src/config/data/LoanProductFormData.json";

const { Text } = Typography;

export const CurrencyForm = (props) => {
  const { fixedDepositDetails } = props;

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        padding: 10,
      }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Currency</Text>}>
            <Input
              value={fixedDepositDetails?.currency?.displayLabel}
              className="of-bold-disable-input"
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Decimal Places</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.currency?.decimalPlaces}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Multiples Of</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.currency?.inMultiplesOf}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* </Form> */}
    </Card>
  );
};
